import { Record } from 'immutable';
import MachineFilterV2Constants from '~/ducks/machine-filter-v2/constants';

const keys: Fields = {
  name: '',
  translationKey: undefined,
  label: undefined,
};

interface Fields {
  name: string;
  translationKey?: string;
  label?: string;
}

export default class NameRecord extends Record<Fields>(keys) {
  static createTagsNameRecord(label: string) {
    return new NameRecord({
      label,
      name: MachineFilterV2Constants.TAGS_FILTER_NAME,
    });
  }

  getName(): string {
    return this.name;
  }

  getTranslationKey(): string | undefined {
    return this.translationKey;
  }

  getLabel(): string | undefined {
    return this.label;
  }
}
